import { render, staticRenderFns } from "./DvrCameraCreateDialog.vue?vue&type=template&id=4af90eee&scoped=true"
import script from "./DvrCameraCreateDialog.vue?vue&type=script&lang=js"
export * from "./DvrCameraCreateDialog.vue?vue&type=script&lang=js"
import style0 from "./DvrCameraCreateDialog.vue?vue&type=style&index=0&id=4af90eee&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af90eee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4af90eee')) {
      api.createRecord('4af90eee', component.options)
    } else {
      api.reload('4af90eee', component.options)
    }
    module.hot.accept("./DvrCameraCreateDialog.vue?vue&type=template&id=4af90eee&scoped=true", function () {
      api.rerender('4af90eee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/schoolconfig/camera/DvrCameraCreateDialog.vue"
export default component.exports